"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Page"));



//////////////////
// WEBPACK FOOTER
// ./src/docs/common/Page/index.ts
// module id = 618
// module chunks = 0